import { Modal, Button } from "antd";

interface IProps {
  visualizar: boolean;
  setVisualizar: any;
}
import Inversion from "../../../assets/comunas/inversionporarea.png"

export const ModalAvisoInfo: React.FC<IProps> = (props: IProps) => {

  const onCancel = () => {
    props.setVisualizar(false)
  }

  return (
    <Modal
      className="ant-modal-close-x2"
      maskStyle={{
        backgroundColor: "rgba(6, 100, 144 ,0.71)",
      }}
      visible={props.visualizar}
      onCancel={onCancel}
      width={800}
      footer={[
        <Button key="B_CERRAR_1" className="button-gray-ghost m-0" onClick={onCancel}>
          Cerrar
        </Button>,
      ]}
      cancelButtonProps={{ style: { display: "none" } }}
    >
      <div style={{fontSize: '1.2em', textAlign: 'center' }}>
        <span className="pb-3 font-size-20px font-family-Montserrat-SemiBold">
          ¡Atención!
        </span>
        <p style={{ textAlign: 'justify' }}>
          Si al ingresar a la plataforma, esta presentando dificultades, le recomendamos refrescar la página e intentarlo nuevamente.
          Si el problema persiste, por favor intente acceder más tarde.
        </p>
        <p style={{ textAlign: 'left' }}>
          Atentamente, <br />
          Equipo de Convocatorias de la Secretaría de Cultura Ciudadana
        </p>
      </div>
    </Modal>
  );
};
